import { useEffect, useState, useRef, useMemo } from "react";
import "./EnrolledStudents.css";
import { Link, useLocation, useNavigate } from "react-router";
import search_bar from "../../../../../../assets/images/search.svg";
import sort from "../../../../../../assets/images/sort.png";
import DataTable from "../../../../../../components/DataTableListing/DataTableListing.jsx";
import BackButton from "../../../../../../components/BackButton/BackButton";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../../../../../features/auth/AuthContext.js";
import EnrollmentResponsiveCards from "../../../../../../modules/admin/Dashboard/RecentEnrollment/EnrollmentResponsiveCards.jsx";

import {
  fetchDepartmentTeachers,
  fetchDepartmentStudents,
  fetchMyStudents,
} from "../../../../../../state/actions/getDepartmentDataAction";
import DataTableListing from "../../../../../../components/DataTableListing/DataTableListing.jsx";
import FloatingAIButton from "../../../../../../components/FloatingAIButton/FloatingAIButton.jsx";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../../../../../state/reducers/chatDrawerReducers";

const TABS = [" Department Teachers", "Department Students", "My Students"];
const BASE_GRADE_OPTIONS = [
  { label: "All Grades", value: "" },
  { label: "Pre-Kindergarten", value: "1" },
  { label: "Kindergarten", value: "2" },
  { label: "Grade 1", value: "3" },
  { label: "Grade 2", value: "4" },
  { label: "Grade 3", value: "5" },
  { label: "Grade 4", value: "6" },
  { label: "Grade 5", value: "7" },
  { label: "Grade 6", value: "8" },
  { label: "Grade 7", value: "9" },
  { label: "Grade 8", value: "10" },
  { label: "Grade 9", value: "11" },
  { label: "Grade 10", value: "12" },
  { label: "Grade 11", value: "13" },
  { label: "Grade 12", value: "14" },
];

const PROSCHOOL_EXTRA_GRADES = [
  { label: "Undergraduate", value: "15" },
  { label: "Graduate", value: "16" },
  { label: "Masters", value: "17" },
  { label: "Doctorate", value: "18" },
  { label: "Post Doctorate", value: "19" },
  { label: "Corporate", value: "20" },
];

const sortOptions  = [
  { label: "Name : A - Z", value: "Name:A-Z" },
  { label: "Name : Z - A", value: "Name:Z-A" },
  { label: "Newest First", value: "Newest" },
  { label: "Oldest First", value: "Oldest-First" },
];

export default function MyDepartmentHod() {
  const [activeTab, setActiveTab] = useState("Department Teachers");
  const [searchValue, setSearchValue] = useState("");
  const [gradeOpen, setGradeOpen] = useState(false);
  const [selectedGrade, setSelectedGrade] = useState("All Grades");
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [sortValue, setSortValue] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortPos, setSortPos] = useState({ top: 0, left: 0 });
  const [gradePos, setGradePos] = useState({ top: 0, left: 0 });
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const [open,setOpen]=useState(false);
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });
    const tabRefs = useRef({});
  const location = useLocation();
   useEffect(() => {
    const el = tabRefs.current[activeTab];
    if (el) {
      setIndicatorStyle({
        left: el.offsetLeft,
        width: el.offsetWidth,
      });
    }
  }, [activeTab]);

  const sortRef = useRef(null);
  const gradeRef = useRef(null);
 
  const dispatch = useDispatch();
  const { token } = useAuth();
  const navigate =useNavigate()

  const globalState = useSelector((state) => state.globalState);

  const isMarketplace = globalState?.enabled_modules?.includes("marketplace");

  const GradeOptions = useMemo(
    () =>
      isMarketplace
        ? [...BASE_GRADE_OPTIONS, ...PROSCHOOL_EXTRA_GRADES]
        : BASE_GRADE_OPTIONS,
    [isMarketplace]
  );
 
  const TeacherId = globalState?.teacher_details?.data?.teacher_id;
  const SubjectId = globalState?.teacher_details?.data?.department_role_subject_id;
  const subjectName =
    globalState?.teacher_details?.data?.department_role_subject_name?.charAt(0).toUpperCase() +
    globalState?.teacher_details?.data?.department_role_subject_name?.slice(1);
    
  const {
    departmentStudents,
    departmentTeachers,
    myStudents,
    loading,
    departmentTeachersCount,
    departmentStudentsCount,
    myStudentsCount,
  } = useSelector((state) => state.getDepartmentData);

  const school_id = useSelector(
  (state) => state.globalState?.teacher_details?.data?.school_id
);
 const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchValue), 400);
    return () => clearTimeout(timer);
  }, [searchValue]);

  /* ── Reset filters when tab changes ── */
  useEffect(() => {
    setSearchValue("");
    setDebouncedSearch("");
    setSelectedGrade("");
    setSortValue("");
    setCurrentPage(1);
  }, [activeTab]);

  /* ── Close dropdowns on outside click ── */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sortRef.current  && !sortRef.current.contains(e.target))  setShowSortMenu(false);
      if (gradeRef.current && !gradeRef.current.contains(e.target)) setGradeOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  /* ---------------- API CALL ---------------- */
const handleSortClick = (e) => {
  const rect = e.currentTarget.getBoundingClientRect();

  setSortPos({
    top: rect.bottom + 5,
    left: rect.left,
  });

  setShowSortMenu((prev) => !prev);
};

const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

const handleGradeClick = (e) => {
  const rect = e.currentTarget.getBoundingClientRect();

  setGradePos({
    top: rect.bottom + 5,
    left: rect.left,
  });

  setGradeOpen((prev) => !prev);
};
const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    const day = date.toLocaleString("en-GB", { day: "2-digit" });
    const month = date.toLocaleString("en-GB", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  };
const onStudentViewProfile = (student_id) => {
    navigate(`/student/${student_id}`,{
      state: { from: location.pathname }
    });
  };
// Fetch all 3 APIs on mount
useEffect(() => {
  if (!token) return;
  dispatch(fetchDepartmentStudents({ token, SubjectId, filters: {school_id} }));
  dispatch(fetchMyStudents(token, TeacherId, {}));
}, [token, dispatch, TeacherId, SubjectId, school_id]);

useEffect(() => {
  if (!token) return;

  const filters = {
    sort: sortValue || undefined,
    search: debouncedSearch || undefined,
    grade: selectedGrade?.value || undefined,
    page:   currentPage,
    school_id: school_id
  };

  if (activeTab === "Department Teachers") {
    dispatch(fetchDepartmentTeachers(token, SubjectId, filters));
  } else if (activeTab === "Department Students") {
    dispatch(fetchDepartmentStudents({ token, SubjectId, filters }));
  } else if (activeTab === "My Students") {
    dispatch(fetchMyStudents(token, TeacherId, filters));
  }
}, [token, dispatch, TeacherId, SubjectId, activeTab, sortValue, debouncedSearch, selectedGrade, currentPage, school_id]);

  /* ---------------- DATA FORMAT ---------------- */

  const DepartmentTeachersData = (departmentTeachers ?? []).map((t) => ({
    key: t.teacher_id,
    name: t.teacher_name || "",
    teacherId: t.teacher_id,
    grade: t.grade_name || "",
    email: t.email || "",
    joinedOn: t.teachers_join_date,
    avatar: t.ai_avatar || null,
  }));



  const myStudentsData = (myStudents ?? []).map((s) => ({
    key: s.student_id,
    name: s.student_name || "",
    studentId: s.student_id,
    grade: s.grade_name || "",
    gradeId: s.grade_id,
    email: s.email || "",
    joinedOn: s.students_join_date,
    avatar: s.student_profile_pic || null,
  }));

  const DepartmentStudentsData = (departmentStudents ?? []).map((s) => ({
    key: s.student_id,
    name: s.student_name || "",
    studentId: s.student_id,
    grade: s.grade_name || "",
    gradeId : s.grade_id ,
    email: s.email || "",
    joinedOn: s.students_join_date,
    avatar: s.student_profile_pic || null,
  }));

  const sourceData =
    activeTab === "Department Teachers"
      ? DepartmentTeachersData
      : activeTab === "Department Students"
      ? DepartmentStudentsData
      : myStudentsData;

 const filteredData = sourceData;

  const totalCount =
    activeTab === "Department Teachers" ? (departmentTeachersCount ?? 0) :
    activeTab === "Department Students" ? (departmentStudentsCount ?? 0) :
    (myStudentsCount ?? 0);
  /* ---------------- TABLE ---------------- */

  const columns = [
    {
      key: "name",
      title:
        activeTab === "Department Teachers" ? "Teacher Name" : "Student Name",
      render: (value, row) => (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {row.avatar ? (
            <img
              src={row.avatar}
              alt={value}
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          ) : (
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: "#e2e8f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 13,
                color: "#94a3b8",
                fontWeight: 600,
              }}
            >
              {value?.charAt(0)}
            </div>
          )}

          <span>{value}</span>
        </div>
      ),
    },

    {
      key: activeTab === "Department Teachers" ? "teacherId" : "studentId",
      title: activeTab === "Department Teachers" ? "Teacher ID" : "Student ID",
    },

    ...(activeTab !== "Department Teachers"
      ? [{ key: "grade", title: "Grade" }]
      : []),

    { key: "email", title: "Email ID" },

    {
      key: "joinedOn",
      title: "Joined On",
      render: (v) => {
        if (!v) return "-";
        // a Small Check for "DD-MM-YYYY" or "YYYY-MM-DD" or ISO format
        let date;
        if (/^\d{2}-\d{2}-\d{4}$/.test(v)) {
          // DD-MM-YYYY
          const [day, month, year] = v.split("-");
          date = new Date(`${year}-${month}-${day}`);
        } else if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
          // YYYY-MM-DD
          date = new Date(v);
        } else if (!isNaN(Date.parse(v))) {
          // ISO or other valid date string
          date = new Date(v);
        } else {
          return v;
        }

        return date
          .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          .replace(/ (\d{4})$/, ", $1");
      },
    },

    {
      key: "action",
      title: "Action",
      render: (_, row) => (
        <span
           onClick={() => {
        if (activeTab === "Department Teachers") {
    console.log("Navigating to teacher with state:", { from: "/dashboard/my-department" });
    navigate(`/teacher/${row.teacherId}`, {
      state: { from: "/dashboard/my-department" },
          });
        } else {
          navigate(`/student/${row.studentId}`, {
            state: { from: "/dashboard/my-department" },
          });
        }
      }}
          style={{
            color: "#0068FF",
            fontSize: 13.5,
            fontWeight: 500,
            textDecoration: "none",
          }}
        >
          View Profile
        </span>
      ),
    },
  ];

  return (
    <div className="enrolled-students-container">
      <BackButton handleClick={() => navigate(location.state?.from || "/dashboard/home")} buttonName="Back" />

      <h4
        className="enrolled-students-title"
        style={{
          fontSize: "18px",
          fontWeight: 500,
          fontFamily: "Poppins",
          marginBottom: "18px",
        }}
      >
        My Department - {subjectName}
      </h4>

      {/* Tabs */}

      <div className="students-tabs hidden md:!flex gap-4 mb-3">
        <button
          className={`tab-btn ${
            activeTab === "Department Teachers" ? "active" : ""
          }`}
          onClick={() => setActiveTab("Department Teachers")}
        >
          Department Teachers ({departmentTeachersCount ?? 0})
        </button>

        <button
          className={`tab-btn ${
            activeTab === "Department Students" ? "active" : ""
          }`}
          onClick={() => setActiveTab("Department Students")}
        >
          Department Students ({departmentStudentsCount ?? 0})
        </button>

        <button
          className={`tab-btn ${activeTab === "My Students" ? "active" : ""}`}
          onClick={() => setActiveTab("My Students")}
        >
          My Students ({myStudentsCount ?? 0})
        </button>
      </div>

      {/* Toolbar */}
          <div className="md:hidden w-full mb-3 relative">
        <div className="relative">
          <div className="flex items-center justify-between py-2 text-sm font-medium cursor-pointer relative">
            <div
              onClick={() => setOpen(!open)}
              className="flex items-center gap-2 relative"
            >
              <span
                ref={(el) => (tabRefs.current[activeTab] = el)}
                className="text-gray-800"
              >
                {activeTab}
              </span>

              <svg
                className={`w-4 h-4 text-gray-600 transition-transform duration-300 ${
                  open ? "rotate-180" : ""
                }`}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>

          <div className="absolute left-[64px] -translate-x-1/2 w-[80%] h-[1px] bg-gray-300"></div>

          <span
            className="absolute bottom-[-2px] h-[4px] bg-blue-600 transition-all duration-300"
            style={{
              left: indicatorStyle.left,
              width: indicatorStyle.width,
            }}
          />
        </div>

        {/* DROPDOWN */}
        {open && (
          <div className="absolute left-0 top-full w-full bg-white z-50 shadow-md">
            {TABS.map((tab) => (
              <div
                key={tab}
                onClick={() => {
                  handleTabClick(tab);
                  setOpen(false);
                }}
                className={`w-full px-2 py-2 text-sm cursor-pointer ${
                  activeTab === tab
                    ? "text-blue-600 font-semibold"
                    : "text-gray-700"
                } border-b border-gray-200`}
              >
                {tab}
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="es-toolbar" style={{ overflow: "visible" }}>
        <div className="search-bar">
          <img src={search_bar} alt="search" />

          <input
            type="text"
            placeholder={`Search ${
              activeTab === "Department Teachers" ? "Teachers" : "Students"
            }...`}
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>

        <div className="es-toolbar-right">
          {/* Grade Filter */}

          {activeTab !== "Department Teachers" && (
            <div
              style={{
                position: "relative",
                width: "fit-content",
                padding: "0 10px",
              }}
              ref={gradeRef}
            >
              <button
                className="grade-dropdown"
                onClick={handleGradeClick}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {selectedGrade ? selectedGrade.label : "All Grades"}
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  style={{ marginLeft: 8, marginRight: 4 }}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 4L6 8L10 4"
                    stroke="#64748b"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              {gradeOpen && (
                <div
                  className="sort-menu"
                  style={{
                    position: "absolute",
                    top: "110%",
                    left: 0,
                    zIndex: 9999,
                    minWidth: "170px",
                  }}
                >
                  {GradeOptions.map((option) => (
                    <div
                      key={option.value}
                      className="sort-options"
                      onClick={() => {
                        setSelectedGrade(option);
                        setCurrentPage(1);
                        setGradeOpen(false);
                      }}
                      style={{
                        color:
                          selectedGrade?.value === option.value
                            ? "#0068FF"
                            : "#374151",
                        fontWeight:
                          selectedGrade?.value === option.value ? 600 : 400,
                        background:
                          selectedGrade?.value === option.value
                            ? "#f0f7ff"
                            : "#fff",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background = "#f9fafb")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background =
                          selectedGrade?.value === option.value
                            ? "#f0f7ff"
                            : "#fff")
                      }
                    >
                      {option.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Sort Dropdown */}
          <div style={{ position: "relative" }} ref={sortRef}>
            <button className="sort-button" onClick={handleSortClick}>
              <img src={sort} alt="sort" />
              Sort
            </button>

            {showSortMenu && (
              <div
                className="sort-menu"
                style={{
                  position: "fixed",
                  top: sortPos.top,
                  left: sortPos.left,
                  zIndex: 9999,
                  minWidth: "170px",
                }}
              >
                {sortOptions.map((option) => (
                  <div
                    className="sort-options"
                    key={option.value}
                    onClick={() => {
                      setSortValue(option.value);
                      setCurrentPage(1);
                      setShowSortMenu(false);
                    }}
                    style={{
                      color: sortValue === option.value ? "#0068FF" : "#374151",
                      fontWeight: sortValue === option.value ? 600 : 400,
                      background:
                        sortValue === option.value ? "#f0f7ff" : "#fff",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "#f9fafb")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background =
                        sortValue === option.value ? "#f0f7ff" : "#fff")
                    }
                  >
                    {option.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Table */}

      <div>
        {isMobile ? (
          <EnrollmentResponsiveCards
            data={filteredData.map((item) => ({
              ...item,
              id: item.studentId || item.teacherId,
              profilePic: item.avatar,
              student_name: item.name,
              student_id: item.studentId,
              teacher_id: item.teacherId,
              grade: item.grade,
              email: item.email,
              joinDate: formatDate(item.joinedOn),
            }))}
            onCardClick={
              activeTab === "Department Teachers"
                ? (item) => navigate(`/teacher/${item.id}`, {
                    state: { from: "/dashboard/my-department" },
                  })
                : (item) => navigate(`/student/${item.id}`, {
                    state: { from: "/dashboard/my-department" },
                  })
            }
            userType={
              activeTab === "Department Teachers" ? "teacher" : "student"
            }
            showActions={false}
          />
        ) : (
          <DataTableListing
            columns={columns}
            dataSource={filteredData}
            rowKey="key"
            loading={loading}
            pagination={
              totalCount > 12
                ? {
                    currentPage: currentPage,
                    total: totalCount,
                    pageSize: 12,
                    onChange: (page) => setCurrentPage(page),
                  }
                : false
            }
            checkable={false}
            emptyText={`No ${
              activeTab === "Department Teachers" ? "teachers" : "students"
            } found`}
          />
        )}

      <FloatingAIButton
        onClick={() => {
        dispatch(setDrawerState(!chatDrawerState.isOpen));
        dispatch(setIsWebAllowed(true));
        dispatch(setQueryMetaData(null));
        }}
      />
    </div>
    </div>
  );
}